import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";

import { extendObservable } from 'mobx';


@inject('core')
@observer
export default class ListStylePicker extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			picking: false
		}
	}

	render() {
		const { core, product_id } = this.props
		const { picking }          = this.state
		
		var picker = null
		
		if (picking) {
			picker = Object.keys(core.listTypes).map((key) => {
				
				const classes = ['inline-button']
				if (key == core.ui.shoppingListType) classes.push('selected')
					
				return <div className={classes.join(' ')} key={key} onClick={() => {
					this.setState({picking: false})
					core.setShoppingListType(key)
				}}>{core.listTypes[key]
				}</div>
			})			
		}
		else {
		
			picker = <div className="inline-button" onClick={() => {this.setState({picking: true})}}>
				{ core.listTypes[core.ui.shoppingListType] }
			</div>
			
		}
				
		return <div id="list-style-picker">{picker}</div>
	}
	
}


